module.exports = __webpack_public_path__ + "static/media/icon-success.f735d355.svg";